const zhHK = {
  HEADER_TITLE: "2020年第四季",
  PREVIOUS_ISSUES: "其他期數",
  LINK_REIT: "領展",
  CHANNEL_823: "823頻道",
  HOME: "主頁",
  CEOS_VIEWS: "領航視野",
  CORPORATE_NEWS: "企業資訊",
  FEATURE_STORIES: "專題故事",
  LINK_TOGETHER_INITIATIVES: "愛•匯聚",
  THE_LINK_MOMENTS: "領展時光",
  CLOSE: "收起",
  MENU: "選單",
  COPYRIGHT_DISCLAIMER: "免責聲明及使用條款",
  ALL_RIGHT_RESERVED: "© 領展資產管理有限公司，版權所有，不得轉載。",
  LINKEDIN: "領展 LinkedIn",
  TWITTER: "領展 Twitter",
  FACEBOOK: "領展愛‧匯聚計劃 Facebook",
  INSTAGRAM: "領展 Instagram",
  YOUTUBE: "領展 YouTube",
  WEIBO: "「領展房地產」微博",
  WECHAT: "「領展房地產」微信",
  SCAN_IN_WECHAT: "微信掃一掃",
  LINKS_WECHAT_PAGE: "「領展房地產」 微信專頁",
  LINKS_WEIBO_PAGE: "「領展房地產」 微博專頁",
  COVER: "封面故事",
  BACK_TO_TOP: "置頂",
  TOP: "置頂",
  LINK_REIT_WECHAT_QR_CODE: "「領展房地產」 微信二維碼",
  STORY1: "十五年不癢",
  STORY2: "看不到，<br/>一樣去得到",
  STORY3: "「攝」獵人心",
  STORY4: "光影15載",
  STORY5: "餐餐有得揀",
  COVER_IMG_TITLE: "培育職場新星",
  READ_MORE: "閱讀更多",
  PAST: "過去",
  CURRENT: "現在",
}
export default zhHK
